import React from 'react';
import Const from './Const';
import FilterExchange from './FilterExchange';
import PopupWarningNoTicker from './PopupWarningNoTicker';
import Table from './Table';
import Export from '../common/Export';

const AllScore = ({ parentRef }) => (
  <div className="tab-content d-flex flex-fill flex-column h-auto">
    <div className="d-flex w-100 ml-0 mb-10 mr-0 justify-content-between ">
      <FilterExchange />
      <Export page={'score'} {...parentRef} />
    </div>
    <PopupWarningNoTicker parentRef={parentRef} />
    <Table listConfigTable={Const.listColumn} />
  </div>
);

export default AllScore;
